import script from "./Form.vue?vue&type=script&lang=ts&setup=true"
export * from "./Form.vue?vue&type=script&lang=ts&setup=true"

import "./Form.vue?vue&type=style&index=0&id=9ec11a94&lang=scss"

const __exports__ = script;

export default __exports__